import { MultiSelectDropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchAggregators } from 'utils/api/aggregatorApi'

type Props = {
  setValue: any
  resetForm: any
  error?: string
  label: string
  name: string
  required?: boolean
  defaultSelected?: []
  isActive?: boolean
}

const AggregatorsDropdown = ({
  resetForm,
  setValue,
  error,
  label,
  name,
  required,
  defaultSelected,
  isActive,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getAggregators = async () => {
    try {
      const { data } = await fetchAggregators({
        limit: 500,
        page: 1,
        isActive,
      })
      const aggregators = data?.docs?.map((aggregator: any) => ({
        label: aggregator.aggregatorName,
        value: aggregator._id,
        disabled: false,
      }))

      if (!aggregators || aggregators.length <= 0) {
        return setOptions([])
      }
      setOptions(aggregators)
    } catch (error) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAggregators()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <MultiSelectDropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      includeSelectAll={options?.length > 0}
      defaultSelected={defaultSelected}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Aggregators Found',
                value: 'NO_AGGREGATORS',
                disabled: true,
              },
            ]
          : options
      }
      reset={resetForm}
    />
  )
}

export default memo(AggregatorsDropdown)
